export class SDKInteropError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SDKInteropError';
  }
}

export class UnsupportedFeatureError extends SDKInteropError {
  constructor(message: string) {
    super(message);
    this.name = 'UnsupportedFeatureError';
  }
}

export class UnsupportedScriptError extends SDKInteropError {
  constructor(message: string) {
    super(message);
    this.name = 'UnsupportedScriptError';
  }
}

export class SdkMisconfigurationError extends SDKInteropError {
  constructor(message: string) {
    super(message);
    this.name = 'SdkMisconfigurationError';
  }
}
